var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import { timeoutPromise } from 'bernie-core';
import { getErrorString } from 'bernie-logger';
import { action, observable, runInAction } from 'mobx';
import { getMessageId, getTraceId, getTrackingInfoForLoggingFromHeaders } from '../common/logging-utils';
import { ActivityGroupViewType } from '../common/__generated__/api';
import { initializeSortAndFilterObject } from '../components/srp/sort-filter/sort-filter-mapper';
import { updateSearchCriteriaStore } from '../helpers/activity-search-helper';
import { LXStore } from './lx-store';
import { STORE_EVENTS } from './store-events';
var ActivitySearchStore = /** @class */function (_super) {
  __extends(ActivitySearchStore, _super);
  function ActivitySearchStore(bexApiSource, state, bexConfigs, logger, appConfig, requestOrContext) {
    if (state === void 0) {
      state = {};
    }
    if (appConfig === void 0) {
      appConfig = {};
    }
    var _this = _super.call(this, bexApiSource, state, bexConfigs, logger, appConfig, requestOrContext) || this;
    _this.activityGroups = [];
    _this.destinationViewList = [];
    _this.listViewActivities = [];
    _this.isBrowser = true;
    _this.retainBrowserFocus = false;
    _this.pageInfo = null;
    _this.paginationInfo = null;
    _this.query = {};
    _this.searchSummary = null;
    _this.universalSortAndFilter = null;
    _this.sortAndFilterObject = {};
    _this.selectedCategories = [];
    _this.isGridLayoutListViewEnabled = false;
    _this.noMatchesFound = null;
    _this.firstLoadActivityCount = 0;
    if (appConfig) {
      _this.firstLoadActivityCount = appConfig.firstLoadActivityCount;
    }
    return _this;
  }
  ActivitySearchStore.prototype.hydrate = function (data) {
    _super.prototype.hydrate.call(this, data);
  };
  ActivitySearchStore.prototype.searchSetup = function () {
    this.loadingActivities = true;
    this.showMoreLoading = false;
    this.listViewActivities = [];
    this.searchError = false;
    this.activityGroups = [];
    this.showMoreButton = true;
  };
  ActivitySearchStore.prototype.clearResponse = function () {
    this.searchSummary = null;
  };
  ActivitySearchStore.prototype.resetActivitySearchStore = function () {
    this.clearResponse();
    this.searchSetup();
    this.searchSummary = null;
    this.uisPayload = undefined;
    this.regionName = undefined;
    this.noMatchesFound = null;
  };
  // for destination view only
  ActivitySearchStore.prototype.fetchActivitiesSearchDestinationView = function (searchCriteriaStore, analyticsStore, query, searchVariables, pageIdentity, indexOfGroupToUpdate, overrideAllGroups, shouldUpdateCriteria) {
    var _this = this;
    var _a, _b;
    if (overrideAllGroups === void 0) {
      overrideAllGroups = true;
    }
    if (shouldUpdateCriteria === void 0) {
      shouldUpdateCriteria = true;
    }
    if (this.logtracing) {
      this.logger.logEvent(STORE_EVENTS.DESTINATION_QUERY_FETCHED, JSON.stringify(searchVariables), "traceid=".concat(getTraceId(this.headers), " messageid=").concat(getMessageId(this.headers)));
    }
    return timeoutPromise(this.bexApiSource.activityDestinationViewSearch(searchVariables, pageIdentity, getTraceId(this.headers), getMessageId(this.headers)).then(function (response) {
      runInAction('update bex api activities search from response', function () {
        var activitySearch = response.data.activitySearch;
        var showMoreLoading = false;
        _this.destinationViewSearchSuccess(activitySearch, response.extensions.analytics, indexOfGroupToUpdate, overrideAllGroups, showMoreLoading);
      });
      searchCriteriaStore.setGroundTransfersBannerCookie();
      if (shouldUpdateCriteria) {
        updateSearchCriteriaStore(searchCriteriaStore, _this, query);
      }
      searchCriteriaStore.isQueryStringUpdated = !shouldUpdateCriteria;
    }).then(function () {
      if (_this.toPublishPageView()) {
        analyticsStore.resetAnalyticsForNewPage();
        analyticsStore.publishClientSidePayload(_this.uisPayload);
      }
    }).catch(function (error) {
      runInAction('recovering from bex api activities search call breakdown', function () {
        _this.searchFailed(searchVariables, error);
      });
      throw error;
    }), this.serverSide ? (_a = this.appConfig.timeout) === null || _a === void 0 ? void 0 : _a.serverStoreFetch : (_b = this.appConfig.timeout) === null || _b === void 0 ? void 0 : _b.clientStoreFetch, "store=search fetch=fetchActivitiesSearchDestinationView timeout ".concat(getTrackingInfoForLoggingFromHeaders(this.headers))).catch(function (error) {
      runInAction('recovering from bex api activities search call breakdown', function () {
        _this.searchFailed(searchVariables, error);
      });
      throw error;
    });
  };
  ActivitySearchStore.prototype.searchFailed = function (searchVariables, error) {
    this.loadingActivities = false;
    this.showMoreLoading = false;
    this.logger.logEvent(STORE_EVENTS.BFF_SEARCH_POOPED, searchVariables, getErrorString(error));
    this.searchError = true;
  };
  ActivitySearchStore.prototype.destinationViewSearchSuccess = function (activityDestinationViewSearch, analytics, indexOfGroupToUpdate, overrideAllGroups, showMoreLoading) {
    var _a;
    var _b, _c, _d, _e, _f;
    this.loadingActivities = false;
    if (activityDestinationViewSearch.activityGroups && activityDestinationViewSearch.activityGroups.length > 0) {
      if (overrideAllGroups) {
        this.activityGroups = activityDestinationViewSearch.activityGroups;
      } else {
        var groupWithActivityList = activityDestinationViewSearch.activityGroups.find(function (group) {
          return group.viewType === ActivityGroupViewType.ACTIVITY_LIST;
        });
        if (groupWithActivityList && indexOfGroupToUpdate !== null) {
          (_a = this.activityGroups[indexOfGroupToUpdate].activityTiles).push.apply(_a, __spreadArray([], __read(groupWithActivityList.activityTiles), false));
          this.showMoreButton = groupWithActivityList.action !== null;
          var resultsDisplayedTextGroup = activityDestinationViewSearch.activityGroups.find(function (group) {
            return group.viewType === ActivityGroupViewType.TEXT;
          });
          var text = (_b = this.activityGroups[indexOfGroupToUpdate - 1].activityTiles[0].activityText) === null || _b === void 0 ? void 0 : _b.text;
          if (resultsDisplayedTextGroup) {
            if (((_c = this.activityGroups[indexOfGroupToUpdate + 1]) === null || _c === void 0 ? void 0 : _c.viewType) === ActivityGroupViewType.TEXT) {
              this.activityGroups[indexOfGroupToUpdate + 1] = resultsDisplayedTextGroup;
            }
            if (((_d = this.activityGroups[indexOfGroupToUpdate - 1]) === null || _d === void 0 ? void 0 : _d.viewType) === ActivityGroupViewType.TEXT) {
              if (text) {
                text = (_e = resultsDisplayedTextGroup.activityTiles[0].activityText) === null || _e === void 0 ? void 0 : _e.text;
              }
            }
          }
        }
      }
    }
    this.showMoreLoading = showMoreLoading;
    this.universalSortAndFilter = activityDestinationViewSearch.universalSortAndFilter;
    this.initializeSortFilter();
    // Initialize cateogries which are coming in the URL as filter
    this.initializeCategories(this.query);
    this.uisPayload = analytics;
    this.searchSummary = activityDestinationViewSearch.searchSummary;
    this.pageInfo = activityDestinationViewSearch.searchSummary.pageInfo;
    this.paginationInfo = activityDestinationViewSearch.searchSummary.paginationInfo;
    this.regionName = activityDestinationViewSearch.searchSummary.resolvedRegion && activityDestinationViewSearch.searchSummary.resolvedRegion.regionName || this.query.location;
    this.searchError = false;
    this.pageTitle = (_f = activityDestinationViewSearch.pageTitle) !== null && _f !== void 0 ? _f : '';
    this.noMatchesFound = activityDestinationViewSearch.noMatchesFound;
  };
  ActivitySearchStore.prototype.toPublishPageView = function () {
    return !this.showMoreLoading;
  };
  ActivitySearchStore.prototype.initializeSortFilter = function () {
    if (!this.universalSortAndFilter) {
      return;
    }
    this.sortAndFilterObject = initializeSortAndFilterObject(this.universalSortAndFilter);
  };
  ActivitySearchStore.prototype.initializeCategories = function (query) {
    var _this = this;
    this.selectedCategories = [];
    var categoriesAndFilter = query && query['filter.categories'] ? query['filter.categories'].split(',') : [];
    var categories = categoriesAndFilter.filter(function (item) {
      var _a;
      return !((_a = _this.sortAndFilterObject.filters) === null || _a === void 0 ? void 0 : _a.categories[item]);
    });
    var newCategory = categories.filter(function (item) {
      return !_this.selectedCategories.includes(item);
    });
    newCategory === null || newCategory === void 0 ? void 0 : newCategory.forEach(function (key) {
      _this.selectedCategories.push(key);
    });
  };
  __decorate([observable], ActivitySearchStore.prototype, "activityGroups", void 0);
  __decorate([observable], ActivitySearchStore.prototype, "destinationViewList", void 0);
  __decorate([observable], ActivitySearchStore.prototype, "listViewActivities", void 0);
  __decorate([observable], ActivitySearchStore.prototype, "loadingActivities", void 0);
  __decorate([observable], ActivitySearchStore.prototype, "isBrowser", void 0);
  __decorate([observable], ActivitySearchStore.prototype, "retainBrowserFocus", void 0);
  __decorate([observable], ActivitySearchStore.prototype, "name", void 0);
  __decorate([observable], ActivitySearchStore.prototype, "pageInfo", void 0);
  __decorate([observable], ActivitySearchStore.prototype, "paginationInfo", void 0);
  __decorate([observable], ActivitySearchStore.prototype, "query", void 0);
  __decorate([observable], ActivitySearchStore.prototype, "regionName", void 0);
  __decorate([observable], ActivitySearchStore.prototype, "searchError", void 0);
  __decorate([observable], ActivitySearchStore.prototype, "searchSummary", void 0);
  __decorate([observable], ActivitySearchStore.prototype, "serverSide", void 0);
  __decorate([observable], ActivitySearchStore.prototype, "universalSortAndFilter", void 0);
  __decorate([observable], ActivitySearchStore.prototype, "showMoreButton", void 0);
  __decorate([observable], ActivitySearchStore.prototype, "showMoreLoading", void 0);
  __decorate([observable], ActivitySearchStore.prototype, "uisPayload", void 0);
  __decorate([observable], ActivitySearchStore.prototype, "sortAndFilterObject", void 0);
  __decorate([observable], ActivitySearchStore.prototype, "selectedCategories", void 0);
  __decorate([observable], ActivitySearchStore.prototype, "isGridLayoutListViewEnabled", void 0);
  __decorate([observable], ActivitySearchStore.prototype, "pageTitle", void 0);
  __decorate([observable], ActivitySearchStore.prototype, "noMatchesFound", void 0);
  __decorate([action], ActivitySearchStore.prototype, "fetchActivitiesSearchDestinationView", null);
  return ActivitySearchStore;
}(LXStore);
export { ActivitySearchStore };